import { PairExchangeRateResponse } from '@shared/api';
import { ApiError } from '@shared/api/@types/api';

const isApiError = (error: ApiError | PairExchangeRateResponse): error is ApiError => (error as any).error != null;

export { isApiError };
